import { Box, BoxProps, styled } from "@mui/material";

export interface PageContainerProps extends BoxProps {
  scaleTransforming: number;
  direction: "row" | "column";
}
export const PageContainer = styled(
  ({ scaleTransforming, direction, ...rest }: PageContainerProps) => <Box {...rest} />
)`
  position: fixed;
  background-color: transparent;
  max-width: 470px;
  height: 785px;
  display: flex;
  flex-direction: ${({ direction }) => direction};
  align-items: ${({ direction }) => direction === 'row' ? 'flex-end' : 'center'};
  overflow: hidden;
  padding: 0 0 5px 0;
  transform: ${({ scaleTransforming }) => `scale(${scaleTransforming})`};
  bottom: 0;
  right: 0;
  transform-origin: bottom right;
`;
